import React from 'react';

import { Paper, Typography } from '@mui/material';
import ImageGrid from '../../../UI/ImageGrid/ImageGrid';
import TestimonialImage from '../../../../assets/CtoLandingPage/Testimonial.png';

const Testimonials = () => {
  return (
    <Paper elevation={20} sx={{ padding: { xs: '2rem', md: '4rem' }, mt: '6rem', borderRadius: 5 }}>
      <Typography
        variant='h6'
        sx={{
          fontWeight: 'bold',
          textAlign: 'center',
          color: 'secondary.main',
          mb: '2rem',
        }}>
        WHAT OUR MEMBERS ARE SAYING
      </Typography>
      <ImageGrid gridSize={4} src={TestimonialImage} alt={'testimonial'} maxWidth={{ maxWidth: '600px' }} />
      <Typography
        variant='body1'
        sx={{
          mt: '1.2rem',
          textAlign: 'center',
          maxWidth: '800px',
          mx: 'auto',
        }}>
        "Finding a network of founders who have taken similar roads to you is hard. The 100 Club has accelerated my
        network growth, and I have met dedicated and friendly founders who are happy to share their journeys and solve
        problems together."
      </Typography>
      <Typography
        variant='body1'
        sx={{
          mt: '1.2rem',
          textAlign: 'center',
          maxWidth: '800px',
          mx: 'auto',
        }}>
        -Ajinkya Bhat, Founder and CEO of Seamless XR
      </Typography>
    </Paper>
  );
};

export default Testimonials;
